import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import AddMeetingContext from 'src/pages/AddMeeting/Context/AddMeeting.context';

export default function RaceHeader() {
  const { t } = useTranslation('common');
  const { formData } = useContext(AddMeetingContext);

  return (
    <div className="add-meeting-form__summarize">
      <div className="add-meeting-form__info">
        <span className="add-meeting-form__id">{ t('addMeetingForm.trackId') }:</span>
        <span className="add-meeting-form__value">{ formData.trackID }</span>
      </div>
      <div className="add-meeting-form__info">
        <span className="add-meeting-form__id">{ t('addMeetingForm.trackName') }:</span>
        <span className="add-meeting-form__value">{ formData.trackName }</span>
      </div>
      <div className="add-meeting-form__info">
        <span className="add-meeting-form__id">{ t('addMeetingForm.meetingName') }:</span>
        <span className="add-meeting-form__value">{ formData.meeting === 'new' ? formData.newMeeting : formData.meeting }</span>
      </div>
      <div className="add-meeting-form__info">
        <span className="add-meeting-form__id">{ t('addMeetingForm.date') }:</span>
        <span className="add-meeting-form__value">{ formData.meetingDate }</span>
      </div>
      <div className="add-meeting-form__info">
        <span className="add-meeting-form__id">{ t('addMeetingForm.races') }:</span>
        <span className="add-meeting-form__value">{ formData.numberRaces }</span>
      </div>
    </div>
  );
}
